import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { I18nProvider } from "@/i18n/I18nContext";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

const queryClient = new QueryClient({
    defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 } },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <I18nProvider>
        <AuthProvider>
            <QueryClientProvider client={queryClient}>
                <App />
                <Toaster position="top-right" richColors />
            </QueryClientProvider>
        </AuthProvider>
    </I18nProvider>,
);
